import FaqPage from "~/components/Faq/FaqPage";

const ForAgents = () => {
  return (
    <FaqPage
      selected={"for-agents"}
      description={
        "A list of Frequently Asked Questions (FAQs) from our agents to support their use of RealEstateAgents.com."
      }
    />
  );
};

export default ForAgents;
